import { useState } from 'react';

import { t } from 'i18next';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { useAppSelector } from '@/app/hooks';
import { ChuteSchedulerActions } from '@/app/slices/chuteScheduler';
import { ChuteScheduleRow } from '@/rtk-query.gql';
import { useAccessToken } from '@/services/auth';
import { updateAspirationTimes as updateAspirationTimesRest } from '@/services/chute-scheduler/api';

type Props = { className?: string };

export const SaveButton = ({ className }: Props) => {
  const dispatch = useDispatch();
  const token = useAccessToken();
  const [params] = useSearchParams();
  const site = params.get('site');
  const date = params.get('date');

  const { isSorted, schedulingRows, selectedSchedulingRows } = useAppSelector(
    (s) => s.chuteScheduler,
  );

  const [restLoading, setRestLoading] = useState(false);
  const isLoading = restLoading;

  const saveTimes = async () => {
    const payload = schedulingRows.map((row: ChuteScheduleRow) => ({
      id: row.aspirationId,
      time: row.aspTime,
    }));

    setRestLoading(true);
    try {
      await updateAspirationTimesRest(token, payload);
    } finally {
      setRestLoading(false);
    }
    dispatch({
      type: ChuteSchedulerActions.UPDATE_SELECTED_SCHEDULING_ROWS,
      rows: [],
    });
  };

  const onClick = () => {
    confirmDialog({
      header: 'Save schedule?',
      message:
        'Once you save, you will not be able to revert without manually re‑applying the original times. Do you want to continue?',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes, Save',
      rejectLabel: 'Cancel',
      accept: saveTimes,
      className: 'max-w-md',
    });
  };

  const disable =
    !date ||
    !site ||
    selectedSchedulingRows.length !== schedulingRows.length ||
    isSorted;

  return (
    <Button
      className={className}
      icon="pi pi-save"
      label={t('common.save')}
      onClick={onClick}
      disabled={disable}
      loading={isLoading}
    />
  );
};
